/**
 * WebSocket class resolver — picks the right WebSocket implementation
 * for the current runtime.
 *
 * - Browser / Deno / Bun: global WebSocket exists, use it.
 * - Node: lazy-import the `ws` npm package (declared as optional peer dep
 *   on @configural/runtime-client). Only Node consumers pay the cost.
 * - Tests / custom runtimes: caller can pass `WebSocketImpl` to
 *   `new CallClient({ WebSocketImpl })` to override.
 */

let cachedNodeWs = null;

export async function resolveWebSocket(override) {
  if (override) return override;
  if (typeof WebSocket !== "undefined") return WebSocket;
  if (cachedNodeWs) return cachedNodeWs;
  try {
    const mod = await import("ws");
    cachedNodeWs = mod.default || mod.WebSocket;
    return cachedNodeWs;
  } catch {
    throw new Error(
      "@configural/runtime-client: no global WebSocket and 'ws' is not installed. " +
      "In Node, add 'ws' as a dependency. In browsers, ensure a global WebSocket exists."
    );
  }
}
